import React, { useState, useEffect } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { IoSendSharp } from "react-icons/io5";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Carousel from "react-bootstrap/Carousel";
import Footer from "./Footer";
import Header from "./Header";
import Scroll from "./Scroll";
import image from "../Assets/profile-banner.jpg";
import image2 from "../Assets/dos_donts.png";
import side_image from "../Assets/home_image1.jpg";
import side_image2 from "../Assets/home_image2.jpg";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import CrackersLoader from './CrackersLoader';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import Sticker from "./Sticker";
import MobileNavigation from "./MobileNavigation";
import "./home.css";
import category_img from "../Assets/category-default.png";

const Home = () => {
  const [isChatBoxVisible, setChatBoxVisible] = useState(false);
  const [showDos, setShowDos] = useState(true);
  const [categories, setCategories] = useState([]);
  const [carouselImages, setCarouselImages] = useState([]);
  const [marqueeText, setMarqueeText] = useState([]);
  const [message, setMessage] = useState("");
  const [homeData, setHomeData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [gallery, setGallery] = useState([]);
  const [clientlogo, setClientLogo] = useState([]);
  const navigate = useNavigate();
  
  const toggleChatBox = () => {
    setChatBoxVisible(!isChatBoxVisible);
  };
  
  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };

  const sendMessage = () => {
    if (!whatsappNumber) {
      console.log("WhatsApp number is not available yet");
      return;
    }
    const whatsappUrl = `https://wa.me/${whatsappNumber.replace("+", "")}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}home.php`);
        const { body } = response.data;
        setCategories(body?.category_front || []);
        setCarouselImages(body?.banner || []);
        setMarqueeText(body?.scrollnew?.map(item => item.msg) || []);
        setGallery(body?.gallery || []);
        setClientLogo(body?.client_logo || []);
      } catch (error) {
        console.error("There was an error fetching the data!", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();   
  }, []);

  useEffect(() => {
    const fetchHomeData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}content.php`);
        const { body } = response.data;
        const { whatsapp_number } = response.data.body.contact;
        setHomeData(body.home);
        setWhatsappNumber(whatsapp_number);
      } catch (error) {
        console.error("Error fetching the about data", error);
      }
    };
    fetchHomeData();
  }, []);

  if (isLoading) {
    return <CrackersLoader />;
  }

  if (!homeData) {
    return <p> </p>;
  }
  
  const handleCategoryClick = (category) => {
    navigate('/quick', { state: { selectedCategory: category.category_name } });
  };

  const doubledMarquee = [...marqueeText, ...marqueeText];

  // Do's and Don'ts Data
  const dosList = [
    { icon: "fa-store", text: "Buy from licensed dealers only" },
    { icon: "fa-fire-extinguisher", text: "Keep safety equipment ready" },
    { icon: "fa-trash", text: "Discard used fireworks in water" },
    { icon: "fa-user-shield", text: "Adult supervision for children" },
    { icon: "fa-book", text: "Read and follow instructions" }
  ];

  const dontsList = [
    { icon: "fa-child", text: "Don't let children play alone" },
    { icon: "fa-tshirt", text: "Avoid synthetic/loose clothing" },
    { icon: "fa-hand-paper", text: "Never hold crackers in hand" },
    { icon: "fa-fire", text: "Keep away from open flames" },
    { icon: "fa-ban", text: "Avoid crowded areas" }
  ];

  return (
    <div className="spark-home-container">
      <Header />

      {/* Carousel Section - EXACTLY LIKE ORIGINAL CODE */}
      <div className="home-carousel-container">
        <Carousel className="home-carousel" interval={3000}>
          {carouselImages.map(({ id, image }) => (
            <Carousel.Item key={id}>
              <img
                className="d-block w-100"
                src={image}
                alt="Carousel slide"
              />
            </Carousel.Item>
          ))}
        </Carousel>
      </div>

      {/* Modern Ticker */}
      <div className="spark-ticker">
        <div className="spark-ticker-content">
          {doubledMarquee.map((text, idx) => (
            <span key={idx}>✨ {text}</span>
          ))}
        </div>
      </div>

      {/* Welcome Section with Glassmorphism & 3D */}
      <div className="spark-welcome">
        <div className="spark-welcome-container">
          <div className="spark-image-card">
            <div className="spark-badge">Since 2019</div>
            <img src={side_image} alt="Fireworks Display" className="spark-3d-image" />
          </div>
          <div className="spark-welcome-content">
            <span className="spark-super-tag">WELCOME TO THE FAMILY</span>
            <h1 className="spark-glow-text">
              <span className="spark-gradient-text">SASTIKHA SREE</span> CRACKERS
            </h1>
            <div className="spark-location">
              <i className="fas fa-map-marker-alt"></i> Wholesale & Retail Shop in <strong>SIVAKASI</strong>
            </div>
            <div className="spark-description" dangerouslySetInnerHTML={{ __html: homeData.value }} />
            
            <div className="spark-feature-grid">
              <div className="spark-feature-chip"><i className="fas fa-check-circle"></i> Premium Quality</div>
              <div className="spark-feature-chip"><i className="fas fa-truck"></i> Timely Delivery</div>
              <div className="spark-feature-chip"><i className="fas fa-tag"></i> Best Prices</div>
            </div>
          </div>
        </div>
      </div>
      
      <Sticker />

      {/* Categories Section with Hover Effects */}
      <div className="spark-categories">
        <div className="spark-section-header">
          <h2>Our <span className="spark-gradient-text">Top Categories</span></h2>
          <div className="spark-header-line"></div>
          <p>Browse our curated collections of premium fireworks</p>
        </div>
        <div className="spark-category-grid">
          {categories.map((category, index) => (
            <div
              key={category.category_id}
              className="spark-category-item"
              onClick={() => handleCategoryClick(category)}
            >
              <div className="spark-category-img">
                <img src={category.image || category_img} alt={category.category_name} />
              </div>
              <h4 className="home-category-name">{category.category_name}</h4>
              {/* <span className="spark-hover-arrow">Explore →</span> */}
            </div>
          ))}
        </div>
      </div>

      {/* Estimate Section with Neon/Blur Effect - Now with Image on Right */}
      <div className="spark-estimate">
        <div className="spark-estimate-container">
          <div className="spark-estimate-card">
            <div className="spark-estimate-badge">
              <i className="fas fa-bolt"></i> Instant Quote
            </div>
            <h2>Get Your Crackers Estimate In Minutes</h2>
            <p>Plan your budget for Diwali, weddings, and celebrations with transparent pricing.</p>
            <Link to="/quick" className="spark-neon-btn">
              Get Free Estimate <i className="fas fa-arrow-right"></i>
            </Link>
          </div>
          {/* Right Side - Hero Section Image (replacing stats) */}
          <div className="spark-estimate-image-wrapper">
            <div className="spark-estimate-image-card">
              <img src={side_image2} alt="Fireworks Display" className="spark-estimate-hero-image" />
              <div className="spark-estimate-image-badge">
                <i className="fas fa-fire"></i> Best Quality Crackers
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Gallery Section - Modern Attractive Title with Original Image Display */}
      <div className="spark-gallery-modern">
        <div className="spark-gallery-header">
          <div className="spark-gallery-icon">
            <i className="fas fa-camera-retro"></i>
            <i className="fas fa-images"></i>
          </div>
          <h2 className="spark-gallery-title">
            <span className="spark-title-gradient">Moments</span> of Joy
          </h2>
          <div className="spark-gallery-subtitle">
            <span className="spark-subtitle-line"></span>
            <p>Capturing the sparkle of every celebration</p>
            <span className="spark-subtitle-line"></span>
          </div>
        </div>

        <div className="home-gallery-container">
          <Swiper
            slidesPerView={4}
            spaceBetween={10}
            breakpoints={{
              320: { slidesPerView: 2, spaceBetween: 10 },
              480: { slidesPerView: 2, spaceBetween: 10 },
              768: { slidesPerView: 3, spaceBetween: 10 },
              1024: { slidesPerView: 4, spaceBetween: 10 },
            }}
            loop={true}
            autoplay={{ delay: 2000, disableOnInteraction: false }}
            modules={[Autoplay]}
            className="home-gallery-swiper"
          >
            {gallery.map((logo, index) => (
              <SwiperSlide key={index} className="home-gallery-slide">
                <div className="home-gallery-card">
                  <img src={logo.image} alt={`Gallery ${index}`} className="home-gallery-image" />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      {/* Safety Section - Modern Redesign (Tips Left, Image Right) */}
      <div className="spark-safety">
        <div className="spark-safety-container">
          <div className="spark-section-header">
            <h2>Safety <span className="spark-gradient-text">Guidelines</span></h2>
            <div className="spark-header-line"></div>
            <p>Celebrate responsibly with these important tips</p>
          </div>

          {/* Mobile Tabs - Only visible on mobile */}
          <div className="spark-mobile-tabs">
            <button className={`spark-tab-btn ${showDos ? 'active' : ''}`} onClick={() => setShowDos(true)}>
              <i className="fas fa-check-circle"></i> Do's
            </button>
            <button className={`spark-tab-btn ${!showDos ? 'active' : ''}`} onClick={() => setShowDos(false)}>
              <i className="fas fa-times-circle"></i> Don'ts
            </button>
          </div>

          {/* Main Layout: Tips Left | Image Right */}
          <div className="spark-safety-layout">
            {/* Left Side - Safety Tips */}
            <div className="spark-safety-tips-container">
              <div className="spark-tips-header">
                <h3>Firework Safety Tips</h3>
                <div className="spark-tips-subtitle">Your safety is our priority</div>
              </div>

              {/* Desktop View - Side by Side Do's and Don'ts */}
              <div className="spark-desktop-view">
                <div className="spark-tips-grid">
                  {/* Do's Column */}
                  <div className="spark-dos-column">
                    <div className="spark-column-header">
                      <div className="spark-column-icon">
                        <i className="fas fa-thumbs-up"></i>
                      </div>
                      <h4>DO'S</h4>
                    </div>
                    <ul className="spark-tips-list">
                      {dosList.map((item, idx) => (
                        <li key={idx} className="spark-tip-item">
                          <div className="spark-tip-icon">
                            <i className={`fas ${item.icon}`}></i>
                          </div>
                          <span className="spark-tip-text">{item.text}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Don'ts Column */}
                  <div className="spark-donts-column">
                    <div className="spark-column-header">
                      <div className="spark-column-icon">
                        <i className="fas fa-ban"></i>
                      </div>
                      <h4>DON'TS</h4>
                    </div>
                    <ul className="spark-tips-list">
                      {dontsList.map((item, idx) => (
                        <li key={idx} className="spark-tip-item">
                          <div className="spark-tip-icon">
                            <i className={`fas ${item.icon}`}></i>
                          </div>
                          <span className="spark-tip-text">{item.text}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Mobile View - Conditional Rendering */}
              <div className="spark-mobile-view">
                {showDos ? (
                  <div className="spark-mobile-card">
                    <div className="spark-mobile-card-header">
                      <div className="spark-tips-icon">
                        <i className="fas fa-thumbs-up"></i>
                      </div>
                      <h3>Safety Do's</h3>
                    </div>
                    <div className="spark-mobile-list">
                      {dosList.map((item, idx) => (
                        <div key={idx} className="spark-mobile-item">
                          <div className="spark-tip-icon" style={{background: 'rgba(40, 167, 69, 0.15)', color: '#28a745'}}>
                            <i className={`fas ${item.icon}`}></i>
                          </div>
                          <span className="spark-tip-text">{item.text}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="spark-mobile-card">
                    <div className="spark-mobile-card-header">
                      <div className="spark-tips-icon">
                        <i className="fas fa-ban"></i>
                      </div>
                      <h3>Safety Don'ts</h3>
                    </div>
                    <div className="spark-mobile-list">
                      {dontsList.map((item, idx) => (
                        <div key={idx} className="spark-mobile-item">
                          <div className="spark-tip-icon" style={{background: 'rgba(220, 53, 69, 0.15)', color: '#dc3545'}}>
                            <i className={`fas ${item.icon}`}></i>
                          </div>
                          <span className="spark-tip-text">{item.text}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Right Side - Image */}
            <div className="spark-safety-image-side">
              <div className="spark-image-wrapper">
                <img src={image2} alt="Safety Do's and Don'ts" className="spark-safety-image" />
                <div className="spark-image-badge">
                  <i className="fas fa-heart"></i> Safe Celebration
                </div>
              </div>
            </div>
          </div>

          {/* Safety Footer Note */}
          <div className="spark-safety-footer">
            <div className="spark-safety-note">
              <i className="fas fa-exclamation-triangle"></i>
              <span>Remember: Celebrate responsibly with safety first!</span>
            </div>
          </div>
        </div>
      </div>

      {/* Brands Section with Marquee */}
      <div className="spark-brands">
        <div className="spark-section-header">
          <h2>Our <span className="spark-gradient-text">Brand Partners</span></h2>
          <div className="spark-header-line"></div>
        </div>
        <div className="spark-brands-marquee">
          {clientlogo.concat(clientlogo).map((logo, index) => (
            <img key={index} src={logo.image} alt="Brand" />
          ))}
        </div>
      </div>

      {/* Floating WhatsApp */}
      <div className="spark-wa-float">
        <a href={`https://wa.me/${whatsappNumber}`} target="_blank" rel="noopener noreferrer" className="spark-wa-btn">
          <FontAwesomeIcon icon={faWhatsapp} />
        </a>
      </div>

      <Scroll />
      <Footer />
      <MobileNavigation />
    </div>
  );
};

export default Home;